export default __webpack_public_path__ + "static/media/A1.5497001e.svg";